import script from "./RadarChart.vue?vue&type=script&setup=true&lang=js"
export * from "./RadarChart.vue?vue&type=script&setup=true&lang=js"

import "./RadarChart.vue?vue&type=style&index=0&id=4dff60f0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dff60f0"]])

export default __exports__